import axios from '../axios'

/*
 * 项目分类
 */

export const selectByPage = (data) => {
    return axios({
        url: '/projectCategory/selectByPage',
        method: 'post',
        data
    })
}
export const insert = (data) => {
    return axios({
        url: '/projectCategory/insert',
        method: 'post',
        data
    })
}
export const update = (data) => {
    return axios({
        url: '/projectCategory/update',
        method: 'post',
        data
    })
}
export const batchUpdateStatus = (data) => {
    return axios({
        url: '/projectCategory/batchUpdateStatus',
        method: 'post',
        data
    })
}
export const batchDelete = (data) => {
    return axios({
        url: '/projectCategory/batchDelete',
        method: 'post',
        data
    })
}
export const transferCategory = (data) => {
    return axios({
        url: '/projectCategory/transferCategory',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/pms/category.js